export class AddSkillModel{
    public crmUserId:number;
    public description:string;
    public name:string;
    public sessionToken:string;
    public skillId:number;
}